export const isLocal = () =>
  ['admin-local.wingalpha.com:5000'].includes(window.location.host);

export const isStage = () =>
  [
    'admin-stage.wingalpha.com',
    'business-stage.wingalpha.com',
    'admin-local.wingalpha.com:5000',
  ].includes(window.location.host);

export const isProd = () =>
  ['admin.wingalpha.com', 'business.wingalpha.com'].includes(
    window.location.host,
  );

export const isBusiness = () =>
  ['business.wingalpha.com'].includes(window.location.host);

export const isDev = () =>
  ['admin-dev.wingalpha.com', 'business-dev.wingalpha.com'].includes(
    window.location.host,
  );

export const isTestBed = () =>
  [
    'admin-testbed.wingalpha.com',
    'admin-testbed-local.wingalpha.com:5000',
  ].includes(window.location.host);
